var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkUnreadDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1 3C15.9659 3.65993 15.9659 4.34007 16.1 5H4.511L12.061 11.662L17.11 7.142C17.536 7.669 18.068 8.108 18.673 8.427L12.072 14.338L4 7.216V19H20V8.9C20.6599 9.03406 21.3401 9.03406 22 8.9V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H16.1ZM21 7C20.606 7 20.2159 6.9224 19.8519 6.77164C19.488 6.62087 19.1573 6.3999 18.8787 6.12132C18.6001 5.84274 18.3791 5.51203 18.2284 5.14805C18.0776 4.78407 18 4.39397 18 4C18 3.60603 18.0776 3.21593 18.2284 2.85195C18.3791 2.48797 18.6001 2.15726 18.8787 1.87868C19.1573 1.6001 19.488 1.37913 19.8519 1.22836C20.2159 1.0776 20.606 1 21 1C21.7956 1 22.5587 1.31607 23.1213 1.87868C23.6839 2.44129 24 3.20435 24 4C24 4.79565 23.6839 5.55871 23.1213 6.12132C22.5587 6.68393 21.7956 7 21 7Z",
    fill: "rgba(0, 0, 0, 0.26)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 4,
    r: 3,
    fill: "rgba(0, 0, 0, 0.26)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkUnreadDisabled);
export default __webpack_public_path__ + "static/media/mark_unread_disabled.626031ed.svg";
export { ForwardRef as ReactComponent };